import styled from "styled-components";
import { motion } from "framer-motion";

export const CardThread = styled.div<{ active: string }>`
  background-color: ${({ active }) => (!active ? "#d3dbe0" : "#fffff")};
  border-radius: 8px;
  border: 1px solid #d3dbe0;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 6px;
  padding-right: 6px;
`;

export const Card = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-family: sans-serif;
  position: relative;

  &:hover .kebab {
    opacity: 1;
  }
`;

export const Row = styled.div`
  display: flex;
  gap: 12px;
`;

export const Avatar = styled.div<{ bg: string }>`
  background-color: ${({ bg }) => bg};
  color: white;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  flex-shrink: 0;
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
`;

export const Name = styled.span`
  font-weight: 600;
  font-size: 14px;
`;

export const Time = styled.span`
  font-size: 12px;
  color: #6b7280; /* muted gray */
`;

export const Text = styled.div`
  font-size: 14px;
  color: #111827;
  margin-top: 4px;
`;

export const Kebab = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.2s ease;
  font-size: 18px;
  user-select: none;
`;

export const Dropdown = motion(styled.div`
  position: absolute;
  top: 36px;
  right: 12px;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 10;
  overflow: hidden;
`);

export const DropdownItem = styled.div`
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background-color: #f0f0f0;
  }
`;
